import React, {useContext} from "react";
import { Link } from "react-router-dom";
import {MainContext} from "../../context/MainContext";
import ServiceContent from "../../content/services/ServicesAll.json"

const ServiceOne = () => {
  const {language,} = useContext(MainContext);

  return (
    <>
      {ServiceContent.map((val, i) => (
        <div
          className="ptf-animated-block"
          data-aos="fade"
          data-aos-delay="0"
          key={i}
        >
          {/* <!--Services Box--> */}
          <div className="ptf-service-box">
            <Link
              to={'/'+val.link}
              className="ptf-service-box__link"
            ></Link>
            <div className="ptf-service-box__icon">
              <i className={val.icon}></i>
            </div>
            <h5 className="ptf-service-box__title">
              {val.titlePart1[language]} <br />
              {val.titlePart2[language]}
            </h5>
            <div className="ptf-service-box__content">
              <p>{val.descriptions[language]}</p>
            </div>
            <div className="ptf-service-box__arrow">
              <i className="lnil lnil-chevron-right"></i>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ServiceOne;
